var map = {
	"./s1.png": 8666,
	"./s10.png": 9415,
	"./s11.png": 3075,
	"./s12.png": 3430,
	"./s2.png": 1283,
	"./s3.png": 9481,
	"./s4.png": 2649,
	"./s5.png": 5890,
	"./s6.png": 3544,
	"./s7.png": 6377,
	"./s8.png": 8466,
	"./s9.png": 911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9421;